import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Item } from './Item';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { BackdropLoader } from '@livable/saas-react-components';
// import { BackdropLoader, toast } from '@livable/saas-react-components';

export const GetForm = observer(_ref => {
  var _store$account, _store$account2;
  let handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const handleSubmit = async () => {
    setIsLoading(true);

    // const resp = await store.portfolios.updatePortfolioAsync.run({
    //   portfolioId: existingPortfolio?.id,
    //   name: portfolioName,
    // });

    // if (resp?.isSuccessful) toast('success', { body: [t('general.successfully_saved')] });

    setIsLoading(false);
    handleModalClose();
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, ((_store$account = store.account) === null || _store$account === void 0 || (_store$account = _store$account.linkedAccounts) === null || _store$account === void 0 ? void 0 : _store$account.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.multipleUnitsSection
  }, (_store$account2 = store.account) === null || _store$account2 === void 0 || (_store$account2 = _store$account2.linkedAccounts) === null || _store$account2 === void 0 ? void 0 : _store$account2.map((account, index) => {
    var _store$account3, _store$account4;
    return /*#__PURE__*/React.createElement(Item, _extends({
      key: account.accountId + "-".concat(index)
    }, _objectSpread(_objectSpread({}, account), {}, {
      isActive: ((_store$account3 = store.account) === null || _store$account3 === void 0 ? void 0 : _store$account3.currentSubAccountFromToken) !== null ? ((_store$account4 = store.account) === null || _store$account4 === void 0 ? void 0 : _store$account4.currentSubAccountFromToken) === account.accountId : false,
      status: index % 2 === 0 ? 'inactive' : 'active'
    }), {
      handleAccountSwitch: handleAccountSwitch
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: handleSubmit,
    disabled: isLoading
  }, t('general.save_and_close')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});